module.exports = __webpack_public_path__ + "img/icon_4.82ac2535.svg";